import publicApi from "../../publicApi";

export type CategoryListItem = {
  category_id: number;
  category_name: string;
  category_image_url: string | null;
};

export const categoriesService = {
  getCategories: async (): Promise<CategoryListItem[]> => {
    const response = await publicApi.get("/categories");
    return response.data;
  },

  getCategoryProducts: async (categoryId: number | string) => {
    const response = await publicApi.get(`/categories/${categoryId}/products`);
    return response.data;
  },
};

